import React from "react";
import { motion } from "framer-motion";
// import "../../../assets/scss/pages/WhatMakesUsDifferent.scss";
import "aos/dist/aos.css"; // Ensure AOS animations are properly imported
import AOS from "aos";
import {
  FaStar,
  FaUsers,
  FaBolt,
  FaChartLine,
  FaRocket,
  FaPiggyBank,
} from "react-icons/fa";



// Import images dynamically
import simpleImg from "../../../assets/images/simple.png";
import intelligentImg from "../../../assets/images/intelligent.png";
import secureImg from "../../../assets/images/secure.png";
import reliableImg from "../../../assets/images/reliable.png";
import hardwareImg from "../../../assets/images/Hardware.png";
import dynamicImg from "../../../assets/images/dynamic.png";
import reportsImg from "../../../assets/images/reports.png";
import scaleableImg from "../../../assets/images/scaleable.png";
import mobileImg from "../../../assets/images/mobile.png";
import analysisImg from "../../../assets/images/analysis.png";
import dashboardImg from "../../../assets/images/dashboard.png";
import customizableImg from "../../../assets/images/customizable.png";

const features = [
  {
    img: simpleImg,
    title: "Simple",
    description:
      "Extensively Simplified User Interface which allows inexperienced people to run ERP conveniently.",
    delay: 0,
  },
  {
    img: intelligentImg,
    title: "Intelligent",
    description:
      "It analyses the usage of User so as to readjust itself to provide the best User Experience.",
    delay: 100,
  },
  {
    img: secureImg,
    title: "Secure",
    description:
      "Here at CODEPLAYERS security comes first! ERP secures your data for as long as a decade or even more.",
    delay: 200,
  },
  {
    img: reliableImg,
    title: "Reliable",
    description:
      "The accuracy of ERP is incomparable. Our product comes up with NIL data corruption possibility.",
    delay: 300,
  },
  {
    img: hardwareImg,
    title: "Utilize Hardware Potential",
    description:
      "Our software operates by exploiting the highest potential of the hardware, making the most of it.",
    delay: 0,
  },
  {
    img: dynamicImg,
    title: "Dynamic ERP Mechanism",
    description:
      "The proposed mechanism achieves easy compatibility and acquisition feasibility under fluctuating needs.",
    delay: 100,
  },
  {
    img: reportsImg,
    title: "User Level Reports",
    description:
      "Our ERP assists to view user session reports based on role-based access control and track user activities.",
    delay: 200,
  },
  {
    img: scaleableImg,
    title: "Scalable",
    description:
      "We endeavor to serve companies of all sizes to reap the benefits of ERP software.",
    delay: 300,
  },
  {
    img: mobileImg,
    title: "Mobile Integration",
    description:
      "It analyses the usage of User so as to readjust itself to provide the best User Experience.",
    delay: 0,
  },
  {
    img: analysisImg,
    title: "Smart Analytics",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorem saepe aut, vel. Nemo.",
    delay: 100,
  },
  {
    img: dashboardImg,
    title: "Dashboard",
    description:
      "Our ERP comes with role-based dashboards which enable users to get an overview of their ecosystem instantly.",
    delay: 200,
  },
  {
    img: customizableImg,
    title: "Highly Customizable",
    description:
      "Organizations may have their own methods of management; therefore, we try our best to mold our product accordingly.",
    delay: 300,
  },
];
  const cards = [
    {
      icon: <FaStar />,
      title: "Innovation at Core",
      description:
        "We don't just follow trends - we set them. Our dedicated R&D team constantly pushes the boundaries of what's possible.",
    },
    {
      icon: <FaUsers />,
      title: "Client-Centric Approach",
      description:
        "Every solution is tailored to your specific needs. We believe in partnerships, not just projects.",
    },
    {
      icon: <FaBolt />,
      title: "24/7 Expert Support",
      description:
        "Round-the-clock dedicated support team ensuring your operations run smoothly without interruption.",
    },
    {
      icon: <FaChartLine />,
      title: "Proven Track Record",
      description:
        "15+ years of excellence with 500+ successful projects across diverse industries.",
    },
    {
      icon: <FaRocket />,
      title: "Future-Ready Solutions",
      description:
        "Our solutions are built with scalability in mind, growing alongside your business.",
    },
    {
      icon: <FaPiggyBank />,
      title: "Cost-Effective Excellence",
      description:
        "Premium solutions that provide exceptional value without breaking your budget.",
    },
  ];

  const headerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  const containerVariants = {
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  // return (
  //   // <div className="differentiators" id="features">
  //   //   <motion.div
  //   //     className="header-content"
  //   //     initial="hidden"
  //   //     whileInView="visible"
  //   //     viewport={{ once: true, amount: 0.3 }}
  //   //     variants={headerVariants}
  //   //   >
  //   //     <h1>
  //   //       {" "}
  //   //       <samp>What Makes Us Different</samp>
  //   //     </h1>
  //   //     <div className="underline" />
        
  //   //   </motion.div>

  //   //   <motion.div
  //   //     className="cards-container"
  //   //     variants={containerVariants}
  //   //     initial="hidden"
  //   //     whileInView="visible"
  //   //     viewport={{ once: true, amount: 0.1 }}
  //   //   >
  //   //     {cards.map((card, index) => (
  //   //       <motion.div
  //   //         key={index}
  //   //         className="card"
  //   //         variants={cardVariants}
  //   //         whileHover={{
  //   //           scale: 1.05,
  //   //           boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
  //   //           transition: { duration: 0.3 },
  //   //         }}
  //   //       >
  //   //         <div className="card-content">
  //   //           <motion.div className="icon-wrapper">
  //   //             <span className="card-icon">{card.icon}</span>
  //   //           </motion.div>
  //   //           <h3>{card.title}</h3>
  //   //           <p>{card.description}</p>
  //   //         </div>
  //   //       </motion.div>
  //   //     ))}
  //   //   </motion.div>
  //   // </div>
  //   <>
    
  //   </>
  // );
const Differentiators = () => {
  React.useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS animations
  }, []);
  return (
    <div className="site-section">
      <div className="container">
        <div className="row justify-content-center mb-5 p-5">
          <div className="col-md-7 text-center">
            <span
              className="subtitle-1 text-uppercase text-primary fw-semibold d-block mb-3"
              style={{ fontSize: "1.2rem", letterSpacing: "0.1rem" }}
            >
              More Features
            </span>
            <h2
              className="section-title-1 font-weight-bold text-dark display-4"
              style={{
                fontSize: "2.5rem",
                lineHeight: "1.3",
                textTransform: "capitalize",
                letterSpacing: "-0.5px",
                animation: "fadeInDown 1s ease-in-out",
              }}
            >
              What makes us different?
            </h2>
          </div>
        </div>
        

        <div className="row">
          {features.map((feature, index) => (
            <div
              key={index}
              className="col-6 col-sm-6 col-md-4 col-lg-3 mb-4"
              data-aos="fade-up"
              data-aos-delay={feature.delay}
            >
              <div className="feature-v2">
                <img src={feature.img} alt={feature.title} className="img-fluid" />
                <br />
                <br />
                <h3 className="font-weight-bold">{feature.title}</h3>
                <p className="text-muted">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Differentiators;